import React, { useCallback } from 'react';

import { useFormBuilderStore } from '../../../pages/builder/state';
import { generateFakeData } from '../helpers/generate-fake-data';
import { usePostMessage } from '../../../hooks';
import { cleanUp } from '../../../components/lets-form';

import { TestToolbar } from './test-toolbar';

const noop = () => {};

const TestToolbarContainer = ({
  top,
  buttons,
  onSave = noop,
  tabOnPreview = 'debug',
  tabOnPlaintext = 'debug'
}) => {
  const form = useFormBuilderStore(state => state.form);
  const editMode = useFormBuilderStore(state => state.editMode);
  const framework = useFormBuilderStore(state => state.framework);
  const plaintextMode = useFormBuilderStore(state => state.plaintextMode);
  const generation = useFormBuilderStore(state => state.generation);
  const { postMessage } = usePostMessage({
    ns: 'lf'
  });

  const {
    setEditMode,
    setPlaintextMode,
    setSidebar,
    setField,
    setGeneration,
    setJsErrors,
    setDefaultValues,
    setFormValue
  } = useFormBuilderStore();

  const handleRegenerate = useCallback(
    () => {
      setJsErrors(null);
      // trigger redesign
      setGeneration(generation + 1);
    },
    [generation, setGeneration, setJsErrors]
  );

  const handleSaveForm = useCallback(
    async () => {
      const cleaned = cleanUp(form, framework);
      // callback
      onSave(cleaned);
      // send message
      postMessage({
        type: 'onSave',
        form: cleaned
      });
    },
    [form, framework, onSave, postMessage]
  );

  return (
    <TestToolbar
      onRegenerate={handleRegenerate}
      buttons={buttons}
      editMode={editMode}
      plaintextMode={plaintextMode}
      onPlaintextMode={plaintextMode => {
        if (!plaintextMode) {
          setPlaintextMode(false);
          setEditMode(true);
          setSidebar('form');
        } else {
          setPlaintextMode(true);
          setEditMode(true);
          setField(null);
          if (tabOnPlaintext) {
            setSidebar(tabOnPlaintext);
          }
        }
      }}
      onEditMode={editMode => {
        if (editMode) {
          setEditMode(true);
          setPlaintextMode(false);
          setSidebar('form');
        } else {
          // preview
          setEditMode(false);
          setPlaintextMode(false);
          setField(null);
          if (tabOnPreview) {
            setSidebar(tabOnPreview);
          }
        }
      }}
      onTestData={() => {
        const fakeData = generateFakeData(form, framework);
        setFormValue(fakeData);
        setDefaultValues(fakeData);
        setJsErrors(null);
        // trigger redesign
        setGeneration(generation + 1);
      }}
      onSaveForm={handleSaveForm}
      style={top != null ? { top } : null}
      placement={top != null && !isNaN(parseInt(top, 10)) && parseInt(top, 10) < 50 ? 'bottomStart' : 'topStart'}
    />
  );
};

export { TestToolbarContainer };
